export const buttonVariants = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    FILTER: 'filter',
} as const

export const buttonSizes = {
    BIG: 'big',
    NORMAL: 'normal',
    SMALL: 'small',
} as const

export const iconPositions = {
    ICON_LEFT: 'left',
    ICON_RIGHT: 'right',
} as const
